export const toggleSiteExpansion = (siteKey, setExpansionState) => {
  setExpansionState((prevState) => {
    const newState = { ...prevState };

    // Toggle the site expansion
    newState[siteKey] = {
      ...newState[siteKey],
      site: !newState[siteKey]?.site,
    };

    // Close all patch expansions when closing the site expansion
    if (!newState[siteKey]?.site) {
      for (const patchKey in newState[siteKey]) {
        if (patchKey !== "site" && newState[siteKey].hasOwnProperty(patchKey)) {
          newState[siteKey][patchKey].patch = false;
        }
      }
      for (const workTypeKey in newState[siteKey]) {
        if (
          workTypeKey !== "site" &&
          newState[siteKey].hasOwnProperty(workTypeKey)
        ) {
          newState[siteKey][workTypeKey].workType = false;
        }
      }
    }

    return newState;
  });
};

export const togglePatchWithoutSiteExpansion = (
  patchKey,
  setExpansionState,
) => {
  setExpansionState((prevState) => {
    const newState = { ...prevState };
    newState[patchKey] = {
      ...newState[patchKey],
      patch: !newState[patchKey]?.patch,
    };
    return newState;
  });
};

export const togglePatchExpansion = (siteKey, patchKey, setExpansionState) => {
  setExpansionState((prevState) => ({
    ...prevState,
    [siteKey]: {
      ...prevState[siteKey],
      [patchKey]: {
        ...prevState[siteKey][patchKey],
        patch: !prevState[siteKey]?.[patchKey]?.patch,
      },
    },
  }));
};

export const toggleWorkTypeExpansion = (
  siteKey,
  workTypeKey,
  setExpansionState,
) => {
  setExpansionState((prevState) => ({
    ...prevState,
    [siteKey]: {
      ...prevState[siteKey],
      [workTypeKey]: {
        ...prevState[siteKey][workTypeKey],
        workType: !prevState[siteKey]?.[workTypeKey]?.workType,
      },
    },
  }));
};
